import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { RequestPermitToDig, RequestPermitToDigVariables } from "./__generated__/RequestPermitToDig";

const REQUEST_PERMIT = gql`
  mutation RequestPermitToDig(
    $id: String
    $permitDataInput: PermitDataInput
    $number: Int!
    $permitRegisterId: String!
    $sourceId: String
    $documentIds: [String!]
    $asBuiltRequired: Boolean!
    $areas: [AreaInput!]
    $permitAssignmentInputs: [PermitAssignmentInput!]
    $calibrationCertificate: CalibrationCertificateInput
    $sitePhotos: [SitePhotoInput]
    $sitePhotoIds: [String]
    $permitTypeId: String
    $fieldValues: [PermitFieldValueInput]
  ) {
    requestPermitToDig(
      input: {
        id: $id
        permitDataInput: $permitDataInput
        number: $number
        permitRegisterId: $permitRegisterId
        sourceId: $sourceId
        documentIds: $documentIds
        asBuiltRequired: $asBuiltRequired
        areas: $areas
        permitAssignmentInputs: $permitAssignmentInputs
        calibrationCertificate: $calibrationCertificate
        sitePhotos: $sitePhotos
        sitePhotoIds: $sitePhotoIds
        permitTypeId: $permitTypeId
        fieldValues: $fieldValues
      }
    ) {
      permitToDig {
        id
      }
    }
  }
`;

export function useRequestPermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    RequestPermitToDig,
    RequestPermitToDigVariables
  >(REQUEST_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
